// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FkF3x","label":"styles_label__pAc9v"};